(function() {
  var drawer = document.getElementById('ghost-cart-drawer');
  var content = document.getElementById('ghost-cart-drawer-content');
  var footer = document.getElementById('ghost-cart-drawer-footer');
  var subtotalNode = document.getElementById('ghost-cart-total');
  var itemsSubtotalNode = document.getElementById('ghost-cart-items-subtotal');
  var compareSubtotalNode = document.getElementById('ghost-cart-subtotal-compare');
  var totalRowNode = document.getElementById('ghost-cart-total-row');
  var discountRowNode = document.getElementById('ghost-cart-discount-row');
  var discountAmountNode = document.getElementById('ghost-cart-discount-amount');
  var discountLabelNode = document.getElementById('ghost-cart-discount-label');
  var countBadge = document.getElementById('ghost-cart-count-badge');
  var panel = drawer ? drawer.querySelector('.ghost-cart-drawer__panel') : null;
  var cartCountNodes = document.querySelectorAll('[data-ghost-cart-count]');

  if (!drawer || !content || !footer || !subtotalNode || !itemsSubtotalNode || !panel) return;

  var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';
  var continueUrl = drawer.getAttribute('data-continue-url') || '/';
  var emptyText = drawer.getAttribute('data-empty-text') || 'Your cart is empty.';
  var emptyBody = drawer.getAttribute('data-empty-body') || '';
  var continueLabel = drawer.getAttribute('data-continue-label') || 'Continue shopping';
  var loadingText = drawer.getAttribute('data-loading-text') || 'Loading cart...';
  var removeText = drawer.getAttribute('data-remove-text') || 'Remove';
  var decreaseText = drawer.getAttribute('data-decrease-text') || 'Decrease quantity';
  var increaseText = drawer.getAttribute('data-increase-text') || 'Increase quantity';
  var updatingText = drawer.getAttribute('data-updating-text') || 'Updating...';
  var errorText = drawer.getAttribute('data-error-text') || 'Could not update your cart. Please try again.';
  var cartJsUrl = drawer.getAttribute('data-cart-js-url') || '/cart.js';
  var cartChangeUrl = drawer.getAttribute('data-cart-change-url') || '/cart/change.js';
  var cartAddUrl = drawer.getAttribute('data-cart-add-url') || '/cart/add.js';
  var cartUpdateUrl = drawer.getAttribute('data-cart-update-url') || '/cart/update.js';
  var discountApplyText = drawer.getAttribute('data-discount-apply-text') || 'Apply';
  var discountApplyingText = drawer.getAttribute('data-discount-applying-text') || 'Applying...';
  var discountSuccessText = drawer.getAttribute('data-discount-success-text') || 'Discount applied.';
  var discountRemovedText = drawer.getAttribute('data-discount-removed-text') || 'Discount removed.';
  var discountErrorText = drawer.getAttribute('data-discount-error-text') || 'Could not apply that discount code. Please try again.';
  var discountInvalidText = drawer.getAttribute('data-discount-invalid-text') || 'That discount code is not valid for your cart.';
  var discountRemoveText = drawer.getAttribute('data-discount-remove-text') || 'Remove';
  var couponDiscountText = drawer.getAttribute('data-coupon-discount-text') || 'Coupon discount';
  var couponDiscountNamedText = drawer.getAttribute('data-coupon-discount-named-text') || 'Coupon ({{ code }})';
  var couponsDiscountText = drawer.getAttribute('data-coupons-discount-text') || 'Coupons';
  var checkoutButton = drawer.querySelector('[data-ghost-cart-checkout]');

  var isRefreshing = false;
  var closeTimer = null;
  var refreshGeneration = 0;
  var lastFocusBeforeDrawer = null;
  var variantCompareAt = window.GhostVariantCompareAt || {};
  var variantImages = window.GhostVariantImages || {};

  function rememberVariantImage(variantId, imageUrl) {
    var variant = Number(variantId || 0);
    var image = String(imageUrl || '').trim();
    if (!variant || !image) return;
    variantImages[variant] = image;
    window.GhostVariantImages = variantImages;
  }

  function normalizeImageUrl(imageUrl) {
    var image = String(imageUrl || '').trim();
    if (!image) return '';

    if (image.indexOf('//') === 0) {
      image = window.location.protocol + image;
    }

    return image;
  }

  function getItemImageUrl(item) {
    if (!item) return '';

    var fromProperty = getItemProperty(item, '_hero_image');
    if (fromProperty) {
      return normalizeImageUrl(fromProperty);
    }

    var variantId = Number(item.variant_id || 0);
    if (variantId && variantImages[variantId]) {
      return normalizeImageUrl(variantImages[variantId]);
    }

    if (item.image) {
      return normalizeImageUrl(item.image);
    }

    if (item.featured_image && item.featured_image.url) {
      return normalizeImageUrl(item.featured_image.url);
    }

    return '';
  }

  function syncImageRegistryFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function(item) {
      var fromProperty = getItemProperty(item, '_hero_image');
      if (fromProperty) {
        rememberVariantImage(item.variant_id, fromProperty);
        return;
      }

      var variantId = Number(item.variant_id || 0);
      if (variantId && variantImages[variantId]) {
        return;
      }

      if (variantId && item.image) {
        rememberVariantImage(variantId, item.image);
      }
    });
  }

  function captureHeroImageFromForm(form, formData) {
    if (!form || !formData) return;

    var card = form.closest(
      '.ghost-catalog-card, .ghost-shop-card, .ghost-product-pdp, .ghost-search-product-card, .ghost-exit-popup__product'
    );
    if (!card) return;

    var activeVariantButton = card.querySelector(
      '.ghost-catalog-card__variant-list button[aria-pressed="true"], ' +
        '.ghost-shop-card__variant-list button[aria-pressed="true"], ' +
        '.ghost-product-pdp__variant-list button[aria-pressed="true"], ' +
        '.ghost-search-product-card__variant-list button[aria-pressed="true"], ' +
        '.ghost-exit-popup__variant-list button[aria-pressed="true"]'
    );
    var heroImage = activeVariantButton ? activeVariantButton.getAttribute('data-image-url') : '';

    if (!heroImage) {
      var catalogImage = card.querySelector('[data-ghost-catalog-image], [data-ghost-card-image], [data-exit-popup-image]');
      heroImage = catalogImage ? catalogImage.getAttribute('src') || '' : '';
    }

    heroImage = normalizeImageUrl(heroImage);
    if (!heroImage) return;

    formData.set('properties[_hero_image]', heroImage);
    rememberVariantImage(formData.get('id'), heroImage);
  }

  function getLastNonEmptyFormValue(formData, name) {
    var values = formData.getAll(name);
    var found = '';
    values.forEach(function(value) {
      var text = String(value || '').trim();
      if (text) found = text;
    });
    return found;
  }

  function getFormProperties(formData) {
    var properties = {};
    formData.forEach(function(value, key) {
      var match = String(key || '').match(/^properties\[(.+)\]$/);
      if (!match) return;
      var text = String(value || '').trim();
      if (!text) return;
      properties[match[1]] = text;
    });
    return properties;
  }

  function parseSellingPlanId(raw) {
    var id = Number(String(raw == null ? '' : raw).trim());
    if (!id || id < 1) return 0;
    return id;
  }

  function getAppstleWidgetPlanId() {
    var widget = document.querySelector('.appstle_sub_widget');
    if (!widget) return 0;

    var checked = widget.querySelector('input[name="selling_plan"]:checked');
    var fromChecked = parseSellingPlanId(
      checked && (checked.getAttribute('data-appstle-real-value') || checked.value)
    );
    if (fromChecked) return fromChecked;

    return parseSellingPlanId(widget.getAttribute('data-selected-selling-plan'));
  }

  function getSellingPlanId(form, formData) {
    var fromAppstle = getAppstleWidgetPlanId();
    if (fromAppstle) return fromAppstle;

    var card = form ? form.closest('[data-ghost-shield-plan]') : null;
    var fromCard = parseSellingPlanId(card && card.getAttribute('data-selling-plan-id'));
    if (fromCard) return fromCard;

    var fromAttr = parseSellingPlanId(form && form.getAttribute('data-selling-plan'));
    if (fromAttr) return fromAttr;

    var found = 0;
    formData.getAll('selling_plan').forEach(function(value) {
      var id = parseSellingPlanId(value);
      if (id) found = id;
    });
    return found;
  }

  function formDataToQuery(formData) {
    var params = [];
    formData.forEach(function(value, key) {
      if (value instanceof File) return;
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : String(value)));
    });
    return params.join('&');
  }

  function replaceQueryParam(body, name, value) {
    var prefix = encodeURIComponent(name) + '=';
    var parts = String(body || '').split('&').filter(function(part) {
      return part && part.indexOf(prefix) !== 0;
    });
    parts.push(prefix + encodeURIComponent(value == null ? '' : String(value)));
    return parts.filter(Boolean).join('&');
  }

  function getSellingPlanFromBody(body) {
    var match = String(body || '').match(/(?:^|&)selling_plan=([^&]*)/);
    if (!match) return 0;
    try {
      return parseSellingPlanId(decodeURIComponent(match[1].replace(/\+/g, ' ')));
    } catch (error) {
      return parseSellingPlanId(match[1]);
    }
  }

  function selectAppstleSubscriptionInput() {
    var widget = document.querySelector('.appstle_sub_widget');
    if (!widget) return 0;

    var subscribe = null;
    var oneTime = null;
    var inputs = widget.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      var id = parseSellingPlanId(inputs[i].getAttribute('data-appstle-real-value') || inputs[i].value);
      if (id) {
        subscribe = inputs[i];
      } else {
        oneTime = inputs[i];
      }
    }
    if (!subscribe) return 0;

    if (oneTime) {
      oneTime.checked = false;
      oneTime.removeAttribute('checked');
      oneTime.disabled = true;
    }

    subscribe.disabled = false;
    subscribe.checked = true;
    subscribe.setAttribute('checked', 'checked');

    var planId = parseSellingPlanId(subscribe.getAttribute('data-appstle-real-value') || subscribe.value);
    if (planId) {
      widget.setAttribute('data-selected-selling-plan', String(planId));
    }
    return planId;
  }

  function stripEmptySellingPlans(body) {
    return String(body || '').split('&').filter(function(part) {
      if (!part) return false;
      if (part.indexOf('selling_plan=') !== 0) return true;
      var raw = part.slice('selling_plan='.length);
      var value = raw;
      try {
        value = decodeURIComponent(raw.replace(/\+/g, ' '));
      } catch (error) {}
      return parseSellingPlanId(value) > 0;
    }).join('&');
  }

  function formAllowsOneTime(form) {
    if (!form) return false;
    if (form.getAttribute('data-one-time') === 'true') return true;
    var card = form.closest('[data-ghost-shield-plan]');
    if (card && card.getAttribute('data-one-time') === 'true') return true;
    return false;
  }

  function applyRequiredSellingPlan(form, body) {
    var cleaned = stripEmptySellingPlans(body);
    if (formAllowsOneTime(form)) return cleaned;
    var fromChecked = getAppstleWidgetPlanId();
    var fromForm = parseSellingPlanId(form && form.getAttribute('data-selling-plan'));
    var fromInput = 0;
    if (form) {
      var defaultInput = form.querySelector('[data-ghost-default-selling-plan]');
      fromInput = parseSellingPlanId(defaultInput && defaultInput.value);
    }
    var planId = fromChecked || fromForm || fromInput;
    var required = Boolean(form && form.getAttribute('data-requires-selling-plan') === 'true');
    if (!required && document.body) {
      if (document.body.classList.contains('ghost-shell--subscription-only')) required = true;
      if (document.body.classList.contains('ghost-shell--shield')) required = true;
    }

    if (required && planId) {
      return replaceQueryParam(cleaned, 'selling_plan', String(planId));
    }
    if (planId && !getSellingPlanFromBody(cleaned)) {
      return replaceQueryParam(cleaned, 'selling_plan', String(planId));
    }
    return cleaned;
  }

  function applyCheckedAppstlePlan(body) {
    selectAppstleSubscriptionInput();
    var widget = document.querySelector('.appstle_sub_widget');
    if (!widget) return body;

    var checked = widget.querySelector('input[name="selling_plan"]:checked');
    var planId = parseSellingPlanId(
      checked && (checked.getAttribute('data-appstle-real-value') || checked.value)
    );
    if (!planId) return body;

    return replaceQueryParam(body, 'selling_plan', String(planId));
  }

  function findAppstleProductForm() {
    return document.querySelector('.ghost-shield__appstle-form')
      || document.querySelector('form[data-product-form]')
      || document.querySelector('form.product-form');
  }

  function serializeCartAddForm(form) {
    if (formAllowsOneTime(form)) {
      var oneTimeData = new FormData(form);
      captureHeroImageFromForm(form, oneTimeData);
      return stripEmptySellingPlans(formDataToQuery(oneTimeData));
    }

    selectAppstleSubscriptionInput();
    var formData = new FormData(form);
    captureHeroImageFromForm(form, formData);
    var body = applyCheckedAppstlePlan(formDataToQuery(formData));
    return applyRequiredSellingPlan(form, body);
  }

  function itemsToSerializedBody(items) {
    var item = items && items[0] ? items[0] : {};
    var parts = [
      'id=' + encodeURIComponent(item.id || ''),
      'quantity=' + encodeURIComponent(item.quantity || 1)
    ];

    if (item.one_time) {
      return parts.join('&');
    }

    if (item.selling_plan) {
      parts.push('selling_plan=' + encodeURIComponent(item.selling_plan));
    }

    if (item.properties && typeof item.properties === 'object') {
      Object.keys(item.properties).forEach(function(key) {
        if (item.properties[key] == null || item.properties[key] === '') return;
        parts.push(
          encodeURIComponent('properties[' + key + ']') + '=' + encodeURIComponent(item.properties[key])
        );
      });
    }

    return applyCheckedAppstlePlan(parts.join('&'));
  }

  function postCartAddSerialized(body) {
    var addUrl = String(cartAddUrl || '/cart/add.js');
    var payload = String(body || '');

    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', addUrl);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function() {
        var text = xhr.responseText || '';
        var data = null;

        try {
          data = text ? JSON.parse(text) : null;
        } catch (parseError) {
          reject(new Error(errorText));
          return;
        }

        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(data);
          return;
        }

        reject(new Error((data && data.description) || 'Unable to add product to cart.'));
      };
      xhr.onerror = function() {
        reject(new Error('Unable to add product to cart.'));
      };

      var send = XMLHttpRequest.prototype.send;
      if (getSellingPlanFromBody(payload)) {
        send = window.__ghostNativeXHRSend || send;
      }
      send.call(xhr, payload);
    });
  }

  function postCartAddFromForm(form) {
    return postCartAddSerialized(serializeCartAddForm(form));
  }

  function getAddedCartItem(payload) {
    if (!payload) return null;
    if (Array.isArray(payload.items) && payload.items.length) {
      return payload.items[0];
    }
    if (payload.variant_id || payload.id) {
      return payload;
    }
    return null;
  }

  function buildCartAddPayload(form, formData) {
    var variantId = Number(getLastNonEmptyFormValue(formData, 'id') || 0);
    var quantity = Number(getLastNonEmptyFormValue(formData, 'quantity') || 1);
    var sellingPlanId = getSellingPlanId(form, formData);
    var properties = getFormProperties(formData);
    var item = {
      id: variantId,
      quantity: quantity > 0 ? quantity : 1
    };

    if (sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return {
      items: [item],
      variantId: variantId,
      sellingPlanId: sellingPlanId,
      compareAt: properties._compare_at || ''
    };
  }

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function(node) {
      return !node.hidden && node.getAttribute('aria-hidden') !== 'true';
    });
  }

  function rememberVariantCompareAt(variantId, compareAtCents) {
    var variant = Number(variantId || 0);
    var compareAt = Number(compareAtCents || 0);
    if (!variant || !compareAt) return;
    variantCompareAt[variant] = compareAt;
    window.GhostVariantCompareAt = variantCompareAt;
  }

  function getItemProperty(item, key) {
    if (!item || !item.properties) return '';

    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i++) {
        if (item.properties[i].key === key) {
          return item.properties[i].value || '';
        }
      }
      return '';
    }

    return item.properties[key] || '';
  }

  function getCompareUnitFromItem(item) {
    var fromProperty = Number(getItemProperty(item, '_compare_at') || 0);
    if (fromProperty > 0) return fromProperty;

    var variantId = Number(item.variant_id || 0);
    if (variantId && variantCompareAt[variantId]) {
      return Number(variantCompareAt[variantId]);
    }

    return Number(item.compare_at_price || 0);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value || ''));
    }

    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    var amount = Number(cents || 0);
    var formatted = (amount / 100).toFixed(2);
    if (moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', formatted);
    }
    if (moneyFormat.indexOf('{{ amount }}') !== -1) {
      return moneyFormat.replace('{{ amount }}', formatted);
    }
    return '$' + formatted;
  }

  function normalizeDiscountCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCartDiscountCodeEntries(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return [];

    return cart.discount_codes
      .map(function(entry) {
        return {
          code: String(entry.code || '').trim(),
          applicable: entry.applicable !== false
        };
      })
      .filter(function(entry) {
        return entry.code;
      });
  }

  function getLineLevelDiscountTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function(sum, item) {
      var allocations = item.line_level_discount_allocations;
      if (!Array.isArray(allocations)) return sum;

      return sum + allocations.reduce(function(lineSum, allocation) {
        return lineSum + Number(allocation.amount || 0);
      }, 0);
    }, 0);
  }

  function getCartLevelDiscountTotal(cart) {
    if (!cart || !Array.isArray(cart.cart_level_discount_applications)) return 0;

    return cart.cart_level_discount_applications.reduce(function(sum, application) {
      return sum + Number(application.total_allocated_amount || 0);
    }, 0);
  }

  function getTotalDiscountAmount(cart) {
    return getCartLevelDiscountTotal(cart) + getLineLevelDiscountTotal(cart);
  }

  function getAppliedDiscountCodes(cart) {
    var codes = [];
    var seen = {};

    getCartDiscountCodeEntries(cart).forEach(function(entry) {
      if (!entry.applicable) return;

      var key = normalizeDiscountCode(entry.code);
      if (!key || seen[key]) return;

      seen[key] = true;
      codes.push(entry.code);
    });

    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function(application) {
        var title = String(application.title || '').trim();
        var key = normalizeDiscountCode(title);
        if (!title || !key || seen[key]) return;

        seen[key] = true;
        codes.push(title);
      });
    }

    return codes;
  }

  function discountWasApplied(cart, code) {
    var normalized = normalizeDiscountCode(code);
    if (!normalized || !cart) return false;

    var matchingEntry = getCartDiscountCodeEntries(cart).find(function(entry) {
      return normalizeDiscountCode(entry.code) === normalized;
    });

    if (matchingEntry) {
      return matchingEntry.applicable;
    }

    if (
      getAppliedDiscountCodes(cart).some(function(appliedCode) {
        return normalizeDiscountCode(appliedCode) === normalized;
      })
    ) {
      return true;
    }

    if (getTotalDiscountAmount(cart) <= 0) {
      return false;
    }

    if (!Array.isArray(cart.items)) {
      return false;
    }

    return cart.items.some(function(item) {
      var allocations = item.line_level_discount_allocations;
      if (!Array.isArray(allocations)) return false;

      return allocations.some(function(allocation) {
        var application = allocation.discount_application || {};
        return normalizeDiscountCode(application.title) === normalized;
      });
    });
  }

  function syncDiscountCodesToSession(cart) {
    var codes = getAppliedDiscountCodes(cart);
    if (!codes.length) return;

    try {
      sessionStorage.setItem('zg_discount', codes.join(','));
    } catch (storageError) {
      /* ignore */
    }
  }

  function buildDiscountPayload(existingCart, newCode) {
    var codes = getAppliedDiscountCodes(existingCart);
    var normalizedNew = String(newCode || '').trim();
    if (!normalizedNew) return null;

    if (!codes.some(function(code) { return code.toLowerCase() === normalizedNew.toLowerCase(); })) {
      codes.push(normalizedNew);
    }

    return codes.join(',');
  }

  function buildDiscountPayloadAfterRemove(existingCart, codeToRemove) {
    var remove = String(codeToRemove || '').trim().toLowerCase();
    var codes = getAppliedDiscountCodes(existingCart).filter(function(code) {
      return code.toLowerCase() !== remove;
    });

    return codes.join(',');
  }

  function cartHasItems(cart) {
    return Boolean(
      cart &&
        Number(cart.item_count || 0) > 0 &&
        Array.isArray(cart.items) &&
        cart.items.length > 0
    );
  }

  function syncCheckoutButton(cart) {
    if (!checkoutButton) return;

    var hasItems = cartHasItems(cart);
    checkoutButton.hidden = !hasItems;
    checkoutButton.disabled = !hasItems;
    checkoutButton.setAttribute('aria-hidden', hasItems ? 'false' : 'true');

    if (hasItems) {
      checkoutButton.removeAttribute('tabindex');
    } else {
      checkoutButton.setAttribute('tabindex', '-1');
    }
  }

  function updateCheckoutLink(cart) {
    if (!checkoutButton) return;

    syncCheckoutButton(cart);

    if (!cartHasItems(cart)) {
      return;
    }

    var checkoutUrl = drawer.getAttribute('data-checkout-url') || '/checkout';
    var codes = getAppliedDiscountCodes(cart);

    if (codes.length) {
      checkoutButton.setAttribute('data-checkout-url', checkoutUrl + '?discount=' + encodeURIComponent(codes.join(',')));
      return;
    }

    checkoutButton.setAttribute('data-checkout-url', checkoutUrl);
  }

  function setDiscountMessage(formRoot, message, type) {
    if (!formRoot) return;

    var messageNode = formRoot.querySelector('[data-ghost-cart-discount-message]');
    if (!messageNode) return;

    messageNode.textContent = message || '';
    messageNode.hidden = !message;
    messageNode.classList.remove('is-success', 'is-error', 'is-removed');

    if (type === 'success') {
      messageNode.classList.add('is-success');
    } else if (type === 'removed') {
      messageNode.classList.add('is-removed');
    } else if (type === 'error') {
      messageNode.classList.add('is-error');
    }
  }

  function getDiscountDisplayRows(cart) {
    var rows = [];
    var seen = {};

    getCartDiscountCodeEntries(cart).forEach(function(entry) {
      if (!entry.applicable) return;

      var key = normalizeDiscountCode(entry.code);
      if (!key || seen[key]) return;

      seen[key] = true;
      rows.push({
        code: entry.code,
        amount: 0
      });
    });

    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function(application) {
        var title = String(application.title || '').trim();
        var key = normalizeDiscountCode(title);
        if (!title || !key) return;

        var amount = Number(application.total_allocated_amount || 0);
        if (seen[key]) {
          rows.forEach(function(row) {
            if (normalizeDiscountCode(row.code) === key) {
              row.amount += amount;
            }
          });
          return;
        }

        seen[key] = true;
        rows.push({
          code: title,
          amount: amount
        });
      });
    }

    if (rows.length === 1 && rows[0].amount === 0) {
      rows[0].amount = getTotalDiscountAmount(cart);
    } else if (rows.length > 1) {
      var lineTotal = getLineLevelDiscountTotal(cart);
      var unallocated = lineTotal;

      rows.forEach(function(row) {
        if (row.amount > 0) {
          unallocated = Math.max(0, unallocated - row.amount);
        }
      });

      rows.forEach(function(row) {
        if (row.amount === 0 && unallocated > 0) {
          row.amount = unallocated;
          unallocated = 0;
        }
      });
    }

    if (!rows.length && getTotalDiscountAmount(cart) > 0) {
      rows.push({
        code: couponDiscountText,
        amount: getTotalDiscountAmount(cart)
      });
    }

    return rows;
  }

  function renderAppliedDiscounts(cart) {
    document.querySelectorAll('[data-ghost-cart-discount-applied]').forEach(function(listNode) {
      var rows = getDiscountDisplayRows(cart);

      if (!rows.length) {
        listNode.innerHTML = '';
        listNode.hidden = true;
        return;
      }

      listNode.hidden = false;
      listNode.innerHTML = rows
        .map(function(row) {
          var code = String(row.code || '').trim();
          var amount = Number(row.amount || 0);

          return (
            '<li class="ghost-cart-discount__applied-item">' +
            '<span class="ghost-cart-discount__applied-label">' + escapeHtml(code) + '</span>' +
            '<span class="ghost-cart-discount__applied-value">-' + formatMoney(amount) + '</span>' +
            '<button type="button" class="ghost-cart-discount__remove" data-ghost-cart-discount-remove data-discount-code="' + escapeHtml(code) + '">' +
            escapeHtml(discountRemoveText) +
            '</button>' +
            '</li>'
          );
        })
        .join('');
    });
  }

  function applyDiscountUpdate(discountPayload) {
    return fetchCartJson(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: discountPayload || ''
      })
    }).then(function() {
      return fetchCartJson(cartJsUrl);
    });
  }

  function handleDiscountApply(formRoot, code, currentCart) {
    var submitButton = formRoot.querySelector('[data-ghost-cart-discount-submit]');
    var inputNode = formRoot.querySelector('[data-ghost-cart-discount-input]');
    var context = formRoot.closest('[data-ghost-cart-discount]');
    var contextName = context ? context.getAttribute('data-context') : 'drawer';
    var normalizedCode = String(code || '').trim();
    var submitLabel = submitButton ? submitButton.textContent : discountApplyText;

    if (!normalizedCode) {
      setDiscountMessage(formRoot, discountInvalidText, 'error');
      return Promise.resolve();
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = discountApplyingText;
    }

    setDiscountMessage(formRoot, '', '');

    var payload = buildDiscountPayload(currentCart, normalizedCode);

    return fetchCartJson(cartJsUrl)
      .catch(function() {
        return currentCart || null;
      })
      .then(function(latestCart) {
        if (latestCart) {
          payload = buildDiscountPayload(latestCart, normalizedCode);
        }

        return applyDiscountUpdate(payload);
      })
      .then(function(cart) {
        if (!discountWasApplied(cart, normalizedCode)) {
          throw new Error(discountInvalidText);
        }

        syncDiscountCodesToSession(cart);

        if (contextName === 'page') {
          renderAppliedDiscounts(cart);
          updateCartPageSummary(cart);
          if (inputNode) inputNode.value = '';
          setDiscountMessage(formRoot, discountSuccessText, 'success');
          return cart;
        }

        renderCart(cart);
        if (inputNode) inputNode.value = '';
        setDiscountMessage(formRoot, discountSuccessText, 'success');
        return cart;
      })
      .catch(function(error) {
        setDiscountMessage(formRoot, error.message || discountErrorText, 'error');
      })
      .finally(function() {
        if (!submitButton) return;
        submitButton.disabled = false;
        submitButton.textContent = submitLabel;
      });
  }

  function handleDiscountRemove(formRoot, codeToRemove, currentCart) {
    var context = formRoot ? formRoot.closest('[data-ghost-cart-discount]') : null;
    var contextName = context ? context.getAttribute('data-context') : 'drawer';
    var normalizedCode = String(codeToRemove || '').trim();

    if (formRoot) {
      setDiscountMessage(formRoot, '', '');
    }

    return fetchCartJson(cartJsUrl)
      .catch(function() {
        return currentCart || null;
      })
      .then(function(latestCart) {
        var payload = buildDiscountPayloadAfterRemove(latestCart || currentCart, normalizedCode);
        return applyDiscountUpdate(payload);
      })
      .then(function(cart) {
        if (normalizedCode && discountWasApplied(cart, normalizedCode)) {
          throw new Error(discountErrorText);
        }

        if (contextName === 'page') {
          syncDiscountCodesToSession(cart);
          renderAppliedDiscounts(cart);
          updateCartPageSummary(cart);
          if (formRoot) {
            setDiscountMessage(formRoot, discountRemovedText, 'removed');
          }
          return cart;
        }

        renderCart(cart);
        if (formRoot) {
          setDiscountMessage(formRoot, discountRemovedText, 'removed');
        }
        return cart;
      })
      .catch(function(error) {
        if (formRoot) {
          setDiscountMessage(formRoot, error.message || discountErrorText, 'error');
        }
      });
  }

  function parseJsonResponse(response) {
    return response.text().then(function(text) {
      var trimmed = (text || '').trim();

      if (!trimmed) {
        throw new Error(errorText);
      }

      if (trimmed.charAt(0) === '<') {
        throw new Error(errorText);
      }

      try {
        return JSON.parse(trimmed);
      } catch (parseError) {
        throw new Error(errorText);
      }
    });
  }

  function fetchCartJson(url, options) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }, options || {})).then(function(response) {
      if (!response.ok) {
        return parseJsonResponse(response).catch(function() {
          throw new Error(errorText);
        }).then(function(payload) {
          throw new Error((payload && payload.description) || errorText);
        });
      }

      return parseJsonResponse(response);
    });
  }

  function renderLoading() {
    content.innerHTML =
      '<div class="ghost-cart-drawer__loading">' +
      '<span class="ghost-cart-drawer__spinner" aria-hidden="true"></span>' +
      '<p>' + escapeHtml(loadingText) + '</p>' +
      '</div>';
    footer.hidden = true;
    drawer.classList.add('is-empty');
    syncCheckoutButton(null);
  }

  function renderError(message) {
    content.innerHTML = '<p class="ghost-cart-drawer__error" role="alert">' + escapeHtml(message) + '</p>';
    footer.hidden = true;
    syncCheckoutButton(null);
  }

  function renderEmpty() {
    content.innerHTML =
      '<div class="ghost-cart-drawer__empty">' +
      '<span class="ghost-cart-drawer__empty-icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">' +
      '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686" />' +
      '</svg></span>' +
      '<p class="ghost-cart-drawer__empty-title">' + escapeHtml(emptyText) + '</p>' +
      (emptyBody ? '<p class="ghost-cart-drawer__empty-body">' + escapeHtml(emptyBody) + '</p>' : '') +
      '<a class="ghost-cart-drawer__empty-action ghost-button ghost-button--primary" href="' + escapeHtml(continueUrl) + '" data-ghost-cart-close>' +
      escapeHtml(continueLabel) +
      '</a>' +
      '</div>';
    footer.hidden = true;
    drawer.classList.add('is-empty');
    syncCheckoutButton(null);
    renderAppliedDiscounts(null);
    itemsSubtotalNode.textContent = formatMoney(0);
    subtotalNode.textContent = formatMoney(0);
    if (compareSubtotalNode) {
      compareSubtotalNode.textContent = '';
      compareSubtotalNode.hidden = true;
    }
    if (totalRowNode) totalRowNode.hidden = true;
    if (discountRowNode) discountRowNode.hidden = true;
    if (discountAmountNode) discountAmountNode.textContent = '';
  }

  function getLineComparePrice(item) {
    var compareUnit = getCompareUnitFromItem(item);
    var quantity = Number(item.quantity || 1);
    var finalLine = Number(item.final_line_price || 0);
    var originalLine = Number(item.original_line_price || 0);
    var compareLine = compareUnit > 0 ? compareUnit * quantity : 0;

    if (compareLine > finalLine) {
      return compareLine;
    }

    if (originalLine > finalLine) {
      return originalLine;
    }

    return 0;
  }

  function getItemsSubtotal(cart) {
    if (!cart) return 0;

    if (cart.items_subtotal_price != null) {
      return Number(cart.items_subtotal_price || 0);
    }

    if (!Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function(sum, item) {
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function hasAppliedCartCoupon(cart) {
    if (!cart) return false;

    if (getTotalDiscountAmount(cart) > 0) {
      return true;
    }

    return getCartDiscountCodeEntries(cart).some(function(entry) {
      return entry.applicable;
    });
  }

  function getCartDiscountTotal(cart) {
    return getTotalDiscountAmount(cart);
  }

  function getDiscountSummaryLabel(cart) {
    var applications =
      cart && Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];

    if (!applications.length) {
      return couponDiscountText;
    }

    if (applications.length === 1) {
      var code = String(applications[0].title || '').trim();
      if (code) {
        return couponDiscountNamedText.replace(/\{\{\s*code\s*\}\}/g, code);
      }
    }

    if (applications.length > 1) {
      return couponsDiscountText;
    }

    return couponDiscountText;
  }

  function getCartCompareSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function(sum, item) {
      var compareLine = getLineComparePrice(item);
      var finalLine = Number(item.final_line_price || 0);
      return sum + (compareLine > finalLine ? compareLine : finalLine);
    }, 0);
  }

  function getCartPageRoot() {
    return document.querySelector('[data-ghost-cart-page]');
  }

  function getCartPageMoneyFormat() {
    var page = getCartPageRoot();
    return page ? page.getAttribute('data-money-format') || moneyFormat : moneyFormat;
  }

  function formatMoneyWithFormat(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || moneyFormat);
    }

    var amount = Number(cents || 0);
    var formatted = (amount / 100).toFixed(2);
    var template = format || moneyFormat;

    if (template.indexOf('{{amount}}') !== -1) {
      return template.replace('{{amount}}', formatted);
    }
    if (template.indexOf('{{ amount }}') !== -1) {
      return template.replace('{{ amount }}', formatted);
    }

    return '$' + formatted;
  }

  function formatCartPageMoney(cents) {
    return formatMoneyWithFormat(cents, getCartPageMoneyFormat());
  }

  function getCartPageDiscountSummaryLabel(cart) {
    var page = getCartPageRoot();
    var couponText = page ? page.getAttribute('data-coupon-discount-text') || couponDiscountText : couponDiscountText;
    var couponNamedText = page
      ? page.getAttribute('data-coupon-discount-named-text') || couponDiscountNamedText
      : couponDiscountNamedText;
    var couponsText = page ? page.getAttribute('data-coupons-discount-text') || couponsDiscountText : couponsDiscountText;
    var applications =
      cart && Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];

    if (!applications.length) {
      return couponText;
    }

    if (applications.length === 1) {
      var code = String(applications[0].title || '').trim();
      if (code) {
        return couponNamedText.replace(/\{\{\s*code\s*\}\}/g, code);
      }
    }

    if (applications.length > 1) {
      return couponsText;
    }

    return couponText;
  }

  function updateCartPageLineItems(cart) {
    var page = getCartPageRoot();
    if (!page || !cart || !Array.isArray(cart.items)) return;

    page.querySelectorAll('[data-cart-item-key]').forEach(function(itemNode) {
      var key = itemNode.getAttribute('data-cart-item-key');
      if (!key) return;

      var item = cart.items.find(function(entry) {
        return entry.key === key;
      });
      if (!item) return;

      var priceNode = itemNode.querySelector('[data-cart-page-line-price]');
      var compareNode = itemNode.querySelector('[data-cart-page-line-compare]');
      var finalLine = Number(item.final_line_price || 0);
      var compareLine = getLineComparePrice(item);

      if (priceNode) {
        priceNode.textContent = formatCartPageMoney(finalLine);
      }

      if (!compareNode) return;

      if (compareLine > finalLine) {
        compareNode.textContent = formatCartPageMoney(compareLine);
        compareNode.hidden = false;
        return;
      }

      compareNode.textContent = '';
      compareNode.hidden = true;
    });
  }

  function updateCartPageSummary(cart) {
    var page = getCartPageRoot();
    if (!page || !cart) return;

    var subtotalNode = page.querySelector('[data-ghost-cart-page-subtotal]');
    var compareSubtotalNode = page.querySelector('[data-ghost-cart-page-compare-subtotal]');
    var discountRowNode = page.querySelector('[data-ghost-cart-page-discount-row]');
    var discountLabelNode = page.querySelector('[data-ghost-cart-page-discount-label]');
    var discountAmountNode = page.querySelector('[data-ghost-cart-page-discount-amount]');
    var totalRowNode = page.querySelector('[data-ghost-cart-page-total-row]');
    var totalNode = page.querySelector('[data-ghost-cart-page-total]');

    var itemsSubtotal = getItemsSubtotal(cart);
    var totalPrice = Number(cart.total_price || 0);
    var compareSubtotal = getCartCompareSubtotal(cart);
    var hasCartDiscount = hasAppliedCartCoupon(cart);

    if (subtotalNode) {
      subtotalNode.textContent = formatCartPageMoney(itemsSubtotal);
    }

    if (compareSubtotalNode) {
      if (compareSubtotal > itemsSubtotal) {
        compareSubtotalNode.textContent = formatCartPageMoney(compareSubtotal);
        compareSubtotalNode.hidden = false;
      } else {
        compareSubtotalNode.textContent = '';
        compareSubtotalNode.hidden = true;
      }
    }

    if (discountRowNode && discountAmountNode) {
      if (hasCartDiscount) {
        discountRowNode.hidden = false;
        discountAmountNode.textContent = '-' + formatCartPageMoney(getCartDiscountTotal(cart));
        if (discountLabelNode) {
          discountLabelNode.textContent = getCartPageDiscountSummaryLabel(cart);
        }
      } else {
        discountRowNode.hidden = true;
        discountAmountNode.textContent = '';
        if (discountLabelNode) {
          discountLabelNode.textContent = getCartPageDiscountSummaryLabel(cart);
        }
      }
    }

    if (totalRowNode) {
      totalRowNode.hidden = !hasCartDiscount && itemsSubtotal === totalPrice;
    }

    if (totalNode) {
      totalNode.textContent = formatCartPageMoney(totalPrice);
    }

    updateCartPageLineItems(cart);
  }

  function updateSubtotalDisplay(cart) {
    var itemsSubtotal = getItemsSubtotal(cart);
    var totalPrice = Number(cart && cart.total_price ? cart.total_price : 0);
    var compareSubtotal = getCartCompareSubtotal(cart);
    var hasCartDiscount = hasAppliedCartCoupon(cart);

    itemsSubtotalNode.textContent = formatMoney(itemsSubtotal);
    subtotalNode.textContent = formatMoney(totalPrice);
    updateCheckoutLink(cart);
    updateCartPageSummary(cart);

    if (discountRowNode && discountAmountNode) {
      if (hasCartDiscount) {
        discountRowNode.hidden = false;
        discountAmountNode.textContent = '-' + formatMoney(getCartDiscountTotal(cart));
        if (discountLabelNode) {
          discountLabelNode.textContent = getDiscountSummaryLabel(cart);
        }
      } else {
        discountRowNode.hidden = true;
        discountAmountNode.textContent = '';
        if (discountLabelNode) {
          discountLabelNode.textContent = couponDiscountText;
        }
      }
    }

    if (totalRowNode) {
      totalRowNode.hidden = !hasCartDiscount && itemsSubtotal === totalPrice;
    }

    if (!compareSubtotalNode) return;

    if (compareSubtotal > itemsSubtotal) {
      compareSubtotalNode.textContent = formatMoney(compareSubtotal);
      compareSubtotalNode.hidden = false;
      return;
    }

    compareSubtotalNode.textContent = '';
    compareSubtotalNode.hidden = true;
  }

  function renderItem(item) {
    if (!item || !item.key) return '';

    var imageUrl = getItemImageUrl(item);
    var imageHtml = imageUrl
      ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy" width="68" height="68">'
      : '';
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="ghost-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    var sellingPlanName = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.name
      : '';
    var planHtml = sellingPlanName
      ? '<p class="ghost-cart-item__plan">' + escapeHtml(sellingPlanName) + '</p>'
      : '';
    var compareLine = getLineComparePrice(item);
    var finalLine = Number(item.final_line_price || 0);
    var compareHtml =
      compareLine > finalLine
        ? '<span class="ghost-cart-item__compare">' + formatMoney(compareLine) + '</span>'
        : '';

    return (
      '<article class="ghost-cart-item" data-cart-item-key="' + escapeHtml(item.key) + '">' +
      '<a class="ghost-cart-item__media" href="' + escapeHtml(item.url) + '">' + imageHtml + '</a>' +
      '<div class="ghost-cart-item__body">' +
      '<div class="ghost-cart-item__head">' +
      '<div class="ghost-cart-item__meta">' +
      '<p class="ghost-cart-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></p>' +
      variantTitle +
      planHtml +
      '</div>' +
      '<div class="ghost-cart-item__pricing">' +
      '<span class="ghost-cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
      compareHtml +
      '</div>' +
      '</div>' +
      '<div class="ghost-cart-item__footer">' +
      '<div class="ghost-cart-item__qty" aria-label="Quantity">' +
      '<button type="button" class="ghost-cart-item__qty-btn" data-cart-qty-decrease aria-label="' + escapeHtml(decreaseText) + '">−</button>' +
      '<span class="ghost-cart-item__qty-value" data-cart-qty-value>' + item.quantity + '</span>' +
      '<button type="button" class="ghost-cart-item__qty-btn" data-cart-qty-increase aria-label="' + escapeHtml(increaseText) + '">+</button>' +
      '</div>' +
      '<button type="button" class="ghost-cart-item__remove" data-cart-remove>' + escapeHtml(removeText) + '</button>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(
      new CustomEvent('ghost:cart:updated', {
        detail: { cart: cart || null }
      })
    );
  }

  function updateCounts(cart) {
    var count = cart && cart.item_count ? cart.item_count : 0;

    cartCountNodes.forEach(function(node) {
      node.textContent = String(count);
      node.hidden = !count;
    });

    if (countBadge) {
      countBadge.textContent = String(count);
      countBadge.hidden = !count;
    }
  }

  function syncCompareRegistryFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function(item) {
      var fromProperty = getItemProperty(item, '_compare_at');
      if (fromProperty) {
        rememberVariantCompareAt(item.variant_id, fromProperty);
        return;
      }

      if (Number(item.compare_at_price || 0) > Number(item.final_price || 0)) {
        rememberVariantCompareAt(item.variant_id, item.compare_at_price);
      }
    });
  }

  function renderCart(cart) {
    syncCompareRegistryFromCart(cart);
    syncImageRegistryFromCart(cart);
    syncDiscountCodesToSession(cart);
    updateCounts(cart);
    notifyCartUpdated(cart);

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      renderEmpty();
      return;
    }

    drawer.classList.remove('is-empty');
    footer.hidden = false;
    updateSubtotalDisplay(cart);
    renderAppliedDiscounts(cart);
    content.innerHTML = '<div class="ghost-cart-drawer__items">' + cart.items.map(renderItem).join('') + '</div>';
  }

  function refreshCart() {
    var generation = ++refreshGeneration;
    isRefreshing = true;
    renderLoading();

    return fetchCartJson(cartJsUrl)
      .then(function(cart) {
        if (generation !== refreshGeneration) {
          return cart;
        }

        renderCart(cart);
        return cart;
      })
      .catch(function(error) {
        if (generation !== refreshGeneration) {
          return;
        }

        renderError(error.message || errorText);
      })
      .finally(function() {
        if (generation === refreshGeneration) {
          isRefreshing = false;
        }
      });
  }

  function invalidateCartRefresh() {
    refreshGeneration += 1;
  }

  function findCartItemNode(key) {
    return content.querySelector('[data-cart-item-key="' + escapeSelector(key) + '"]');
  }

  function changeLineItem(key, quantity) {
    var itemNode = findCartItemNode(key);
    if (itemNode) itemNode.classList.add('is-updating');

    return fetchCartJson(cartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function(cart) {
        try {
          renderCart(cart);
        } catch (renderFailure) {
          return refreshCart();
        }
        return cart;
      })
      .catch(function(error) {
        if (itemNode) itemNode.classList.remove('is-updating');
        renderError(error.message || errorText);
        return refreshCart();
      });
  }

  function openDrawer() {
    window.clearTimeout(closeTimer);
    lastFocusBeforeDrawer = document.activeElement;
    drawer.removeAttribute('hidden');
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function() {
      drawer.classList.add('is-open');
    });

    var closeButton = drawer.querySelector('.ghost-cart-drawer__close');
    if (closeButton) closeButton.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    var restoreFocus = lastFocusBeforeDrawer;
    lastFocusBeforeDrawer = null;

    closeTimer = window.setTimeout(function() {
      drawer.hidden = true;
      drawer.setAttribute('hidden', '');

      if (restoreFocus && typeof restoreFocus.focus === 'function') {
        restoreFocus.focus();
      }
    }, 340);
  }

  content.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var itemNode = target.closest('[data-cart-item-key]');
    if (!itemNode) return;

    var key = itemNode.getAttribute('data-cart-item-key');
    if (!key) return;

    var qtyNode = itemNode.querySelector('[data-cart-qty-value]');
    var currentQty = qtyNode ? Number(qtyNode.textContent || '0') : 0;

    if (target.closest('[data-cart-qty-decrease]')) {
      event.preventDefault();
      changeLineItem(key, Math.max(0, currentQty - 1));
      return;
    }

    if (target.closest('[data-cart-qty-increase]')) {
      event.preventDefault();
      changeLineItem(key, currentQty + 1);
      return;
    }

    if (target.closest('[data-cart-remove]')) {
      event.preventDefault();
      changeLineItem(key, 0);
    }
  });

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.classList.contains('ghost-product-form')) return true;
    if (form.hasAttribute('data-product-form')) return true;
    var action = String(form.getAttribute('action') || form.action || '');
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!isCartAddForm(form)) return;

    event.preventDefault();
    event.stopPropagation();

    if (form.dataset.ghostCartSubmitting === 'true') {
      return;
    }

    var errorNode = form.querySelector('.ghost-product-form__error');
    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }

    var submitButton = form.querySelector('button[type="submit"]');
    var submitLabel = submitButton ? submitButton.textContent : '';
    var addSucceeded = false;

    form.dataset.ghostCartSubmitting = 'true';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = updatingText;
    }

    openDrawer();
    renderLoading();

    var body = serializeCartAddForm(form);
    var formData = new FormData(form);
    var addPayload = buildCartAddPayload(form, formData);
    addPayload.sellingPlanId = getSellingPlanFromBody(body) || addPayload.sellingPlanId;

    if (!addPayload.variantId) {
      form.dataset.ghostCartSubmitting = 'false';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = submitLabel;
      }
      return;
    }

    postCartAddSerialized(body)
      .then(function(payload) {
        var addedItem = getAddedCartItem(payload);
        var hasPlan = !!(addedItem && addedItem.selling_plan_allocation);

        if (addPayload.sellingPlanId && !hasPlan) {
          var subscriptionError = form.getAttribute('data-subscription-error')
            || (form.closest('[data-ghost-shield-plan]') && form.closest('[data-ghost-shield-plan]').getAttribute('data-subscription-error'))
            || 'This product must be added as a monthly subscription.';
          var addedKey = addedItem && addedItem.key;
          if (addedKey) {
            return changeLineItem(addedKey, 0).then(function() {
              throw new Error(subscriptionError);
            });
          }
          throw new Error(subscriptionError);
        }

        addSucceeded = true;
        var variantId = addPayload.variantId;
        var compareFromForm = addPayload.compareAt;
        if (compareFromForm) {
          rememberVariantCompareAt(variantId, compareFromForm);
        } else if (variantId && variantCompareAt[variantId]) {
          rememberVariantCompareAt(variantId, variantCompareAt[variantId]);
        } else if (variantId && window.GhostVariantCompareAt && window.GhostVariantCompareAt[variantId]) {
          rememberVariantCompareAt(variantId, window.GhostVariantCompareAt[variantId]);
        }
        invalidateCartRefresh();
        return refreshCart();
      })
      .catch(function(error) {
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message;
        }

        renderError(error.message || 'Unable to add product to cart.');
      })
      .finally(function() {
        form.dataset.ghostCartSubmitting = 'false';

        if (!submitButton) return;

        submitButton.disabled = false;

        if (!addSucceeded) {
          submitButton.textContent = submitLabel;
        }
      });
  }, true);

  drawer.addEventListener('click', function(event) {
    if (event.target.closest('[data-ghost-cart-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('click', function(event) {
    var openTrigger = event.target.closest('[data-ghost-cart-open]');
    if (!openTrigger) return;

    event.preventDefault();
    openDrawer();
    refreshCart();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
      return;
    }

    if (!drawer.classList.contains('is-open') || event.key !== 'Tab' || !panel) return;

    var focusables = getFocusableElements(panel);
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function getDiscountFormRoot(node) {
    if (!(node instanceof Element)) return null;
    return node.closest('[data-ghost-cart-discount-form]');
  }

  function triggerDiscountApply(formRoot) {
    if (!formRoot) return;

    var inputNode = formRoot.querySelector('[data-ghost-cart-discount-input]');
    var code = inputNode ? inputNode.value : '';

    handleDiscountApply(formRoot, code, null);
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('[data-ghost-cart-discount-form]')) return;

    event.preventDefault();
    triggerDiscountApply(form);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter') return;

    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.matches('[data-ghost-cart-discount-input]')) return;

    var formRoot = getDiscountFormRoot(target);
    if (!formRoot) return;

    event.preventDefault();
    triggerDiscountApply(formRoot);
  });

  document.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var applyButton = target.closest('[data-ghost-cart-discount-submit]');
    if (applyButton) {
      var formRoot = getDiscountFormRoot(applyButton);
      if (formRoot && !(formRoot instanceof HTMLFormElement)) {
        event.preventDefault();
        triggerDiscountApply(formRoot);
        return;
      }
    }

    var removeButton = target.closest('[data-ghost-cart-discount-remove]');
    if (!removeButton) return;

    event.preventDefault();

    var discountRoot = removeButton.closest('[data-ghost-cart-discount]');
    var formRoot = discountRoot ? discountRoot.querySelector('[data-ghost-cart-discount-form]') : null;
    var codeToRemove = removeButton.getAttribute('data-discount-code') || '';

    handleDiscountRemove(formRoot, codeToRemove, null);
  });

  fetchCartJson(cartJsUrl)
    .then(function(cart) {
      if (cart) {
        syncCompareRegistryFromCart(cart);
        syncImageRegistryFromCart(cart);
        syncDiscountCodesToSession(cart);
        updateCounts(cart);
        renderAppliedDiscounts(cart);
        updateCartPageSummary(cart);
        notifyCartUpdated(cart);
      }
    })
    .catch(function() {});

  window.GhostAddToCartFromForm = function(form) {
    if (!(form instanceof HTMLFormElement)) {
      return Promise.reject(new Error('Unable to add product to cart.'));
    }

    openDrawer();
    renderLoading();

    var body = serializeCartAddForm(form);
    var requiredPlan = getSellingPlanFromBody(body);

    return postCartAddSerialized(body).then(function(payload) {
      var addedItem = getAddedCartItem(payload);
      var hasPlan = !!(addedItem && addedItem.selling_plan_allocation);

      if (requiredPlan && !hasPlan) {
        var addedKey = addedItem && addedItem.key;
        if (addedKey) {
          return changeLineItem(addedKey, 0).then(function() {
            throw new Error('This product must be added as a monthly subscription.');
          });
        }
        throw new Error('This product must be added as a monthly subscription.');
      }

      invalidateCartRefresh();
      return refreshCart().then(function() {
        return payload;
      });
    });
  };

  window.GhostAddToCart = function(items) {
    if (!Array.isArray(items) || !items.length) {
      return Promise.reject(new Error('Unable to add product to cart.'));
    }

    var productForm = findAppstleProductForm();
    if (productForm && items[0] && items[0].id && !items[0].one_time) {
      var idField = productForm.querySelector('[name="id"]');
      if (idField) idField.value = String(items[0].id);

      var qtyField = productForm.querySelector('[name="quantity"]');
      if (qtyField && items[0].quantity) {
        qtyField.value = String(items[0].quantity);
      }

      var body = serializeCartAddForm(productForm);
      if (items[0].selling_plan && !getSellingPlanFromBody(body)) {
        body = replaceQueryParam(body, 'selling_plan', String(items[0].selling_plan));
      }

      openDrawer();
      renderLoading();

      return postCartAddSerialized(body).then(function(payload) {
        var addedItem = getAddedCartItem(payload);
        var requiredPlan = Number(items[0] && items[0].selling_plan || 0) || getSellingPlanFromBody(body);
        var hasPlan = !!(addedItem && addedItem.selling_plan_allocation);

        if (requiredPlan && !hasPlan) {
          var addedKey = addedItem && addedItem.key;
          if (addedKey) {
            return changeLineItem(addedKey, 0).then(function() {
              throw new Error('This product must be added as a monthly subscription.');
            });
          }
          throw new Error('This product must be added as a monthly subscription.');
        }

        invalidateCartRefresh();
        return refreshCart().then(function() {
          return payload;
        });
      });
    }

    openDrawer();
    renderLoading();

    return postCartAddSerialized(itemsToSerializedBody(items)).then(function(payload) {
      var addedItem = getAddedCartItem(payload);
      var requiredPlan = Number(items[0] && items[0].selling_plan || 0);
      var hasPlan = !!(addedItem && addedItem.selling_plan_allocation);

      if (requiredPlan && !hasPlan) {
        var addedKey = addedItem && addedItem.key;
        if (addedKey) {
          return changeLineItem(addedKey, 0).then(function() {
            throw new Error('This product must be added as a monthly subscription.');
          });
        }
        throw new Error('This product must be added as a monthly subscription.');
      }

      invalidateCartRefresh();
      return refreshCart().then(function() {
        return payload;
      });
    });
  };
})();
